


















































import { computed, defineComponent, ref, watch } from "@vue/composition-api";

import Tooltip from "@/components/Tooltip.vue";
import { Item } from "@/tools/msa/models/item";
import { Document } from "@/tools/msa/models";
import RepetitionsTooltip from "@/tools/msa/components/RepetitionsTooltip.vue";
import SimpleDateInput from "@/tools/msa/components/inputs/SimpleDateInput.vue";
import { calculateDates } from "@/tools/msa/utils/dates";

interface Props {
  map: Map<string, Item[]>;
  item: Item;
  document: Document;
  selected: boolean;
}

export default defineComponent<Props>({
  name: "ItemRow",
  components: {
    SimpleDateInput,
    RepetitionsTooltip,
    Tooltip
  },
  props: {
    map: { type: Map, required: true },
    item: { type: Object, required: true },
    document: { type: Object, required: true },
    selected: { type: Boolean, default: false }
  },
  setup(props: Props) {
    const date = ref(calculateDates(props.item)[0] || "");

    const changeDate = (event: string) => {
      if (props.item.type === "code_match")
        props.item.match.refers.dates.splice(0, 1, event);
      if (props.item.type === "msa_custom") props.item.date = event;
    };

    watch(
      [
        () => props.item,
        () => props.document.date,
        () =>
          props.item.type === "code_match"
            ? props.item.match.refers.dates
            : props.item.type === "msa_custom"
            ? props.item.date
            : null
      ],
      () => {
        date.value = calculateDates(props.item)[0] || "";
      }
    );

    return {
      date,
      changeDate
    };
  }
});
